import { ProtocolContentData } from "../../protocol";
export default class WeatherObservationData extends ProtocolContentData {
    apress;
    atemp;
    wtemp;
    relhum;
    weather;
    vis;
    twind;
    seastate;
    swell;
    freeText;
    constructor(apress, atemp, wtemp, relhum, weather, vis, twind, seastate, swell, freeText) {
        super();
        this.apress = apress;
        this.atemp = atemp;
        this.wtemp = wtemp;
        this.relhum = relhum;
        this.weather = weather;
        this.vis = vis;
        this.twind = twind;
        this.seastate = seastate;
        this.swell = swell;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=WeatherObservationData.js.map